var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#12B76A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9995 18.166C39.6299 18.166 45.8333 24.3686 45.8335 31.999C45.8335 39.6295 39.63 45.833 31.9995 45.833C24.3691 45.8328 18.1665 39.6294 18.1665 31.999C18.1667 24.3688 24.3692 18.1662 31.9995 18.166ZM31.9995 19.166C24.9236 19.1662 19.1667 24.9231 19.1665 31.999C19.1665 39.0751 24.9235 44.8328 31.9995 44.833C39.0757 44.833 44.8335 39.0752 44.8335 31.999C44.8333 24.923 39.0755 19.166 31.9995 19.166Z",
    stroke: "#12B76A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.313 27.8604C37.5044 27.6689 37.8286 27.6689 38.02 27.8604C38.2111 28.0517 38.211 28.375 38.02 28.5664L30.4595 36.127C30.3655 36.2208 30.2384 36.2734 30.106 36.2734C29.9737 36.2733 29.8473 36.2207 29.7534 36.127L25.98 32.3535C25.7887 32.1622 25.7888 31.8389 25.98 31.6475C26.1714 31.4561 26.4946 31.4561 26.686 31.6475L30.106 35.0674L30.4604 34.7139L37.313 27.8604Z",
    stroke: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessModalIcon);
export default __webpack_public_path__ + "static/media/success-modal-icon.9273cba15742cfada43e40111b93d5f4.svg";
export { ForwardRef as ReactComponent };